import medoc from './../../assets/img/icons/medoc.png';
import espi from './../../assets/img/icons/espi.png';
import psic from './../../assets/img/icons/psic.png';
import fono from './../../assets/img/icons/fono.png';
import lab from './../../assets/img/icons/lab.png';
import opto from './../../assets/img/icons/opto.png';
import cap from './../../assets/img/icons/cap.png';
import est from './../../assets/img/icons/est.png';
import fisio from './../../assets/img/icons/fisio.png';
import covid from './../../assets/img/icons/covid.png';
import gen from './../../assets/img/icons/gen.png';
import inv from './../../assets/img/icons/inv.png';

export const services = [
  {
    name: 'Medicina Ocupacional',
    description: 'Medicina Ocupacional en Neiva',
    longDescription: `DESAT presta a sus clientes el servicio de Medicina Laboral y Valoración de Daño Corporal. Este servicio brinda apoyo a la gestión médico-administrativa y del Sistema de Gestión de Seguridad y Salud en el trabajo. El servicio busca manejar las /b patologías asociadas a la labor /b de manera integral y ajustada a la realidad funcional del trabajador. Siempre ceñido a las exigencias del debido proceso y la normatividad vigente. /n
        En DESAT el examen médico ocupacional es el primer paso para evaluar la aptitud de tus trabajadores para su labor contratada. Contamos con valoraciones específicas como: /n
        /b * Valoración Médica por Reintegro: /b Examen de ingreso a trabajador reintegrado a la organización por cualquier asunto médico-administrativo, en el que se requiere un enfoque objetivo, funcional y un manejo adecuado. /n
        /b * Valoración Médica Post-Incapacidad: /b Se realiza al término de la incapacidad médica temporal. Permite conocer la pertinencia de iniciar el proceso de reintegro o la necesidad de continuar la prescripción de incapacidad temporal con la entidad correspondiente. /n
        /b * Valoración Médica por Reubicación: /b Permite validar el estado de salud del trabajador frente a la labor que va a desempeñar debido a la reubicación. /n
        No subestimes la salud de tus trabajadores. ¡Trabaja con nosotros en la prevención y la detección temprana de patologías laborales!
        `,
    icon: medoc,
    qty: 0,
    indications: '',
    position: 'center',
  },
  {
    name: 'Medicina General',
    description: 'Medicina General en Neiva',
    longDescription: `En DESAT te ayudamos a encontrar las posibles causas de tus afecciones de salud. Además te ayudamos a controlar trastornos de salud crónicos como hipertensión arterial, diabetes, hiperlipidemias, y más.  /n

        ¡Acércate y conoce nuestro servicio! `,
    icon: gen,
    qty: 0,
    indications: '',
    position: 'right',
  },
  {
    name: 'Pruebas COVID-19',
    description: 'Pruebas COVID-19 en Neiva',
    longDescription: `No permitas que el COVID-19 se propague en tu empresa. Una prueba realizada oportunamente puede prevenir pérdidas de /b productividad /b en tu empresa. En DESAT contamos con las tres pruebas de detección de COVID-19. Comprendemos que el tiempo es valioso y cada minuto cuenta cuando se trata de COVID-19, por eso procuramos por tiempos de respuesta cortos.
        `,
    icon: covid,
    qty: 0,
    indications: '',
    position: 'center',
  },
  {
    name: 'Laboratorio Clínico',
    description: 'Laboratorio Clínico en Neiva',
    longDescription: `Dentro de nuestra práctica integral, resulta imperativo realizar pruebas adicionales para examinar la salud de tus empleados. En DESAT contamos con espacios habilitados, equipos modernos, y personal competente para la toma de muestras biológicas. /n
        Realizamos pruebas de cuadro hemático, glicemia, colesterol, triglicéridos, HDL, entre otras. /n
        Detectar patologías temprano, te permite actuar a tiempo.
        `,
    icon: lab,
    qty: 0,
    indications: '',
    position: 'center',
  },
  {
    name: 'Espirometría',
    description: 'Espirometría en Neiva',
    longDescription: `En DESAT /b respiramos /b una cultura de prevención de enfermedades respiratorias. Con esta prueba de tamizaje podemos evaluar la capacidad pulmonar de los trabajadores. Ayudamos a identificar potenciales efectos adversos relacionados con la labor que desempeñan los trabajadores. /n
        ¡Con DESAT puedes respirar tranquilo!
        `,
    icon: espi,
    qty: 0,
    indications: '',
    position: 'center',
  },
  {
    name: 'Psicología',
    description: 'Psicología en Neiva',
    longDescription: `¿Sabías que los riesgos psico-sociales pueden disminuir el desempeño laboral de los trabajadores? En DESAT evaluamos la /b conducta /b de los trabajadores en su entorno laboral individual y colectivo. /n
        Te ayudamos a identificar fuentes de /b estrés laboral/b, dificultades de concentración, falencias de comunicación, y alteraciones comportamentales individuales y grupales que afectan el desempeño de los trabajadores y pueden poner en riesgo la continuidad de los procesos empresariales. /n
        El talento es el pilar fundamental que sostiene el éxito empresarial. ¡Mantén un ambiente laboral óptimo y procura por la salud mental de los trabajadores!
        `,
    icon: psic,
    qty: 0,
    indications: '',
    position: 'left',
  },
  {
    name: 'Audiometría',
    description: 'Audiometría en Neiva',
    longDescription: `Contamos con audiometrías clínicas y tamizajes auditivos que se ciñen a los procedimientos y estándares de vanguardia. Estas valoraciones nos permiten identificar /b afectaciones /b auditivas que pueden interferir con el desempeño laboral de los trabajadores. Para ello contamos con profesionales en fonoaudiología que operan equipos de alta gama como: cabina sonoamortiguada, audímetro digital, y otoscopio.  /n
        No subestimes la incidencia de patologías auditivas. ¡Te invitamos a detectarlas temprano y prevenirlas a tiempo!
        `,
    icon: fono,
    qty: 0,
    indications: '',
    position: 'center',
  },
  {
    name: 'Optometría y Visiometría',
    description: 'Optometría y Visiometría en Neiva',
    longDescription: `El servicio de optometría se realiza en nuestro consultorio totalmente dotado y atendido por especialistas en salud visual. Seguimos los procedimientos y estándares que permiten identificar /b defectos /b refractivos, alteraciones de visión cromática y de profundidad. Además de detectar patologías que afectan el desempeño laboral, también identificamos patologías oculares no asociadas al trabajo. Así, diagnosticamos si la capacidad visual de tus trabajadores es acorde a su ocupación. /n
        No dejes que tu empresa se mueva a tientas, asegura la visión de tus trabajadores con DESAT.
        `,
    icon: opto,
    qty: 0,
    indications: '',
    position: 'center',
  },
  {
    name: 'Capacitación',
    description: 'Capacitaciones en SST en Neiva',
    longDescription: `En DESAT capacitamos en Seguridad y Salud en el Trabajo y temas de actualidad pertinentes a la salud y bienestar de los trabajadores. Además, te /b apoyamos  /b en el diseño y ejecución de campañas y estrategias en pro de lograr una cultura de autocuidado. /n
        Contamos con espacios dedicados a la capacitación con equipos adecuados, que te harán sentir confortable. /n
        “La distancia entre querer y poder se acorta con el entrenamiento”.
        `,
    icon: cap,
    qty: 0,
    indications: '',
    position: 'center',
  },
  {
    name: 'Inv. de Accidentes',
    description: 'Investigación de accidentes en Neiva',
    longDescription: `El que desconoce la historia está condenado a repetirla. De igual forma, si no se investigan los accidentes no hallarás su causa y, por lo tanto, hay altas posibilidades de repetirlos. En DESAT contamos con /b metodologías /b y herramientas validadas en la industria para ayudarte a identificar la causa de los accidentes y a implementar planes de acción efectivos. ¡Te ayudamos a que los accidentes no se repitan!`,
    icon: inv,
    qty: 0,
    indications: '',
    position: 'right',
  },
  {
    name: 'Exámenes Médicos Escolares',
    description: 'Exámenes Médicos Escolares en Neiva',
    longDescription: `En DESAT ayudamos con la detención temprana de defectos en la capacidad visual y auditiva y en la salud general de los estudiantes para mejorar la facilidad de su /b aprendizaje/b. /n
        No esperes a entrar al colegio para hacerle los exámenes de ingreso escolar a tus hijos. /n
        ¡A la escuela y al colegio con salud!
        `,
    icon: est,
    qty: 0,
    indications: '',
    position: 'top',
  },
  {
    name: 'Fisioterapia',
    description: 'Fisioterapia en Neiva',
    longDescription: `¿Sabías que el túnel de carpo y el manguito rotador son de las patologías osteomusculares  que más generan /b incapacidades /b en las empresas? Afecciones osteomusculares como estas se traducen en pérdidas de productividad para las compañías. Nuestro equipo fisioterapéuta realiza valoraciones para identificar afecciones osteomusculares asociadas a la labor. Así, en DESAT te ayudamos a detectar de manera temprana posibles afecciones osteomusculares para prevenirlas efectivamente, para reducir los tiempos improductivos en tu empresa. /n

        Contamos además con valoraciones de capacidad de movimiento y puesto de trabajo, indispensables para evaluar la idoneidad de las instalaciones laborales e identificar fuentes de patologías osteomusculares que pueden afectar la salud de los trabajadores.
        `,
    icon: fisio,
    qty: 0,
    indications: '',
    position: 'center',
  },
];
